import script from "./AnswerInput.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerInput.vue?vue&type=script&setup=true&lang=js"

import "./AnswerInput.vue?vue&type=style&index=0&id=6ea07223&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea07223"]])

export default __exports__